import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import InvitationsDataTable from './InvitationsDataTable'

import UserDatatable from './UsersDatatable'

const TAB_KEYS = {
    users: "users",
    invitations: "Invitations",
}

const menuTabs = [
    {
        labelKey: "users.tab_users",
        key: TAB_KEYS.users,
        component: <UserDatatable />
    },
    {
        labelKey: "users.tab_invitations",
        key: TAB_KEYS.invitations,
        component: <InvitationsDataTable />
    }
]

function SubMenu({ setShowBtns }) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(menuTabs[0])
    useEffect(() => {
        if (activeTab.key === menuTabs[0].key) {
            setShowBtns(true)
        } else {
            setShowBtns(false)
        }
    }, [activeTab])

    return (
        <div className="content-wrapper">
            {/* Content */}
            <div className="mx-md-2 flex-grow-1    pt-0 ">
                <div className="row">
                    <div div className="col-md-12 ">
                        <div className="card">
                            <div className="col-md-10 px-3">
                                <h5 className="card-title m-0 mt-3 me-auto">
                                    {activeTab.key === TAB_KEYS.users ? t('users.team_members') : t('users.invitation_list')}
                                </h5>
                                <ul className="nav nav-pills flex-column flex-md-row my-3">
                                    {
                                        menuTabs.map((tab, index) => {
                                            return (
                                                <li className="nav-item me-2" onClick={() => {
                                                    setActiveTab({
                                                        key: tab.key,
                                                        component: tab.component
                                                    })
                                                }}
                                                    key={`${Math.random(20)}`}>
                                                    <a className={`nav-link ${activeTab.key == tab.key && "active"}`} href="#">{t(tab.labelKey)}</a>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            {activeTab.component}
                        </div>
                    </div>
                </div>
            </div>
            <div className="content-backdrop fade" />
        </div>
    )
}

export default SubMenu
